import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { getCatchError } from '../../../getCatchError';

const setPostUpdateGameFreespin = (params) => {
    return async (dispatch, getState) => {
        try {
            DefaultApi({
                params,
                method: 'post',
                url: urls.POST_DETAIL_UPDATE_GAME_FS
            });
            alert('Игра обновлена')
        } catch (error) {
            //todo доделать catch 
            alert('Ошибка добавления')
            getCatchError(error)
        }
    }
}

export {
    setPostUpdateGameFreespin as SetPostUpdateGameFreespin
}